import Component from '@glimmer/component';
import { tracked } from '@glimmer/tracking';
import { action } from '@ember/object';
import { eventTargetNotInTextbox } from 'donor-elf-web/lib/document-utils';

interface ComponentArgs {
  currentPage: number;
  totalPages: number;
  zeroBottomMargin?: boolean;
  arrowHotKeys?: boolean;
  hideNextAndBack?: boolean;
  onPageChange: (pageNumber: number) => void;
}

export default class PageLinksComponent extends Component<ComponentArgs> {
  @tracked pageVal = '';
  dropdown: any;

  get arrowHotKeys() {
    return this.args.arrowHotKeys || false;
  }

  get isPrevDisabled() {
    return this.args.currentPage === 1;
  }

  get isNextDisabled() {
    return this.args.currentPage === this.args.totalPages;
  }

  @action
  templateDidInsert() {
    // have to wait until next cycle to give other instances a chance to call 'templateWillDestroy'
    setTimeout(() => {
      if (this.arrowHotKeys) {
        if (window.pageLinksHotKeysEnabled) {
          alert(
            '<PageLinks @arrowHotKeys={{true}} /> can only be true for one ' +
              'component instance on the page. There are multiple instances of ' +
              'this component with hotkeys enabled',
          );
          return;
        }
        document.addEventListener('keydown', this.handleDocumentKeyDown);
        window.pageLinksHotKeysEnabled = true;
      }
    });
  }

  @action
  templateWillDestroy() {
    if (this.arrowHotKeys) {
      document.removeEventListener('keydown', this.handleDocumentKeyDown);
      window.pageLinksHotKeysEnabled = false;
    }
  }

  @action
  handleDocumentKeyDown(e: any) {
    if (e.which === 37 && !this.isPrevDisabled && eventTargetNotInTextbox(e)) {
      // Left arrow
      e.preventDefault();
      e.stopPropagation();
      this.changeToPrevPage();
    } else if (
      e.which === 39 &&
      !this.isNextDisabled &&
      eventTargetNotInTextbox(e)
    ) {
      // Right arrow
      e.preventDefault();
      e.stopPropagation();
      this.changeToNextPage();
    }
  }

  closeDropdown() {
    setTimeout(() => {
      this.dropdown?.actions?.close();
    });
  }

  @action
  handleOnOpen(dropdown: any) {
    this.dropdown = dropdown;
    this.pageVal = '';
  }

  @action
  changeToPrevPage() {
    if (!this.isPrevDisabled) {
      this.args.onPageChange(this.args.currentPage - 1);
    }
  }

  @action
  changeToNextPage() {
    if (!this.isNextDisabled) {
      this.args.onPageChange(this.args.currentPage + 1);
    }
  }

  @action
  changeToPage(pageNumber: number) {
    this.args.onPageChange(pageNumber);
    this.closeDropdown();
  }

  @action
  handlePageValInput(e: any) {
    this.pageVal = e.target.value;
  }

  @action
  handleGoClicked() {
    let numberPageVal = Number(this.pageVal || '0');
    if (numberPageVal < 1 || numberPageVal > this.args.totalPages) {
      alert(`Invalid Page. Valid pages are 1 through ${this.args.totalPages}`);
      return;
    }
    this.changeToPage(numberPageVal);
  }
}
